/* eslint-disable @typescript-eslint/ban-ts-comment */
import Input from "./../Shared/Input";
import ImgPlaceholder from "./../../assets/ImgPlaceholder.svg";
import PencilIcon from "./../Icons/PencilIcon";
import Button from "./../Shared/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "./../../utils/consts";
import AddIcon from "./../Icons/AddIcon";
import UploadProfile from "./../Shared/UploadProfile";
import { queryClient } from "./../../main";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import {
  AddConsultant,
  ConsultantDTO,
} from "../../api/Consultation/AddConsultant";
import { useParams } from "react-router-dom";
import { GetConsultantById } from "../../api/Consultation/GetConsultantById";
import { useNavigate } from "react-router-dom";
import Spinner from "../Shared/Spinner";
import { EditConsultant } from "../../api/Consultation/EditConsultant";
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  title: Yup.string().required("Title is required"),
  img_url: Yup.string().required("Photo is required"),
});
interface ContentItem {
  id?: string;
  time: string;
  day: string;
}

const AddNewConsultant = ({ onSuccess }: { onSuccess?: () => void }) => {
  const [consultantDates, setConsultantDates] = useState<ContentItem[]>([
    { time: "", day: "" },
  ]);
  const addContent = () => {
    setConsultantDates([...consultantDates, { time: "", day: "" }]);
  };
  const navigate = useNavigate();
  const removeContent = (index: number) => {
    const updatedContents = [...consultantDates];
    updatedContents.splice(index, 1);
    setConsultantDates(updatedContents);
  };
  const { id } = useParams();
  const consultantId = id || "";

  const { data: ConsultantData, isLoading: isConsultantLoading } = useQuery({
    queryFn: () => GetConsultantById(consultantId),
    queryKey: ["consultants", consultantId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!id,
  });
  const Consultant = ConsultantData?.data;
  useEffect(() => {
    if (Consultant) {
      formik.setValues({
        title: Consultant.title,
        name: Consultant.name,
        img_url: Consultant.img_url,
      });

      setConsultantDates(
        Consultant.consultantDates?.map((content) => ({
          id: content.id,
          day: content.day,
          time: content.time,
        })) || []
      );
    }
  }, [Consultant]);
  const { mutate, error, isPending } = useMutation({
    mutationFn: AddConsultant,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["consultants"] });
      toast.success("Consultant added successfully");
      formik.resetForm();
      onSuccess && onSuccess();
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });
  const { mutate: editMutate, isPending: isEditPending } = useMutation({
    mutationFn: (data: ConsultantDTO) => EditConsultant(data, consultantId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["consultants"] });
      toast.success("Consultant Edited successfully");
      formik.setSubmitting(true);
      navigate("/dashboard/consultants");
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      img_url: "",
      title: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        title: values.title,
        img_url: values.img_url,
        name: values.name,
        consultantDates: consultantDates.map((content) => ({
          id: content.id,
          time: content.time,
          day: content.day,
        })),
      };
      if (consultantId) {
        editMutate(payload);
      } else {
        mutate(payload);
      }
    },
  });
  const handleimgUrlUpload = (url: string) => {
    formik.setFieldValue("img_url", url);
  };
  if (isConsultantLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <div className="py-7">
      <h1 className="text-burntBlack font-bold text-[32px] mb-7">{consultantId ? 'Edit Consultant Profile' : 'Add New Consultant'}
      </h1>
      <div className="p-8 rounded-xl bg-white border-black/15 shadow flex flex-col justify-end pt-20 pb-40">
        <form onSubmit={formik.handleSubmit}>
          <Button
            className="!h-12 px-4 !text-sm mb-10 font-bold rounded-md ml-auto !bg-[#4379EE] hover:!bg-primary"
            variant="primary"
            disabled={formik.isSubmitting || isPending || isEditPending}
            type={ButtonTypes.SUBMIT}
          >
            <AddIcon className="mr-1.5" />
            {consultantId ? 'Edit Consultant' : 'Add New Consultant'}
            {isPending ? <Spinner /> : ""}
          </Button>

          <div className="flex gap-12">
            <div className="relative size-[132px] rounded-full object-cover cursor-pointer">
              <UploadProfile
                folder="team_image"
                onFileUploaded={handleimgUrlUpload}
              >
                <div className="absolute z-50 right-0 w-8 h-8 bg-[#2783E9] rounded-full flex items-center justify-center bottom-7">
                  <PencilIcon />
                </div>
                {formik.values.img_url &&
                  formik.values.img_url !== "" &&
                  formik.values.img_url !== "uploading" ? (
                  <img
                    className="rounded-full size-[110px] object-cover"
                    src={formik.values.img_url}
                  />
                ) : (
                  <img
                    className="rounded-full size-[110px] object-cover"
                    src={ImgPlaceholder}
                  />
                )}
              </UploadProfile>
            </div>
            <div className="w-full space-y-5">
              <div className="flex gap-7 w-full">
                <Input
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.name && formik.errors.name
                      ? formik.errors.name
                      : ""
                  }
                  className="w-full"
                  title="Full Name"
                  inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                  name="name"
                  placeholder=""
                />
                                <Input
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.title && formik.errors.title
                      ? formik.errors.title
                      : ""
                  }
                  className="w-full"
                  title="Title"
                  inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                  name="title"
                  placeholder=""
                />

              </div>
              <div className="w-full">
                {consultantDates.map((content, index) => (
                  <div key={index} className="space-y-7 pt-8 w-full">
                    <div className="flex gap-7 w-full">
                    <Input
                      inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                      placeholder=""
                      className="w-full"
                      title={`Consultation Day ${index + 1}`}
                      name={`consultationDay-${index}`}
                      type="text"
                      value={content.day}
                      onChange={(e) => {
                        const updatedContents = [...consultantDates];
                        updatedContents[index].day = e.target.value;
                        setConsultantDates(updatedContents);
                      }}
                    />
                    <Input
                      value={content.time}
                      onChange={(e) => {
                        const updatedContents = [...consultantDates];
                        updatedContents[index].time = e.target.value;
                        setConsultantDates(updatedContents);
                      }}
                      inputStyles=" !h-[50px] !rounded-2xl !border-[#DFEAF2] hover:!border-primary"
                      title={`Consultation Time ${index + 1}`}
                      placeholder=""
                      className="w-full"
                      name={`consultationTime-${index}`}
                      type="text"
                    />

                    </div>
                    {index === 0 && ( // Ensure at least one content section exists
                      <div className="flex w-full justify-between mt-5">
                        <Button
                          type={ButtonTypes.BUTTON}
                          className="before:!bg-primary hover:text-white !text-base !font-bold !h-9 w-20 !border-primary !border-2 text-primary"
                          variant="transparent"
                          onClick={() => removeContent(index)}
                        >
                          Cancel
                        </Button>
                        <Button
                          type={ButtonTypes.BUTTON}
                          variant="primary"
                          className="!h-9 w-20 !text-base !font-bold"
                          onClick={addContent}
                        >
                          Add
                        </Button>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {error instanceof AxiosError && (
                <span className="text-red-500 font-bold text-lg">
                  {error?.response?.data?.message || "An error occurred"}
                </span>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddNewConsultant;
